// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3O4pO","selects":"Documents_selects__3ugDV"};